import { render } from "./TextProject.vue?vue&type=template&id=2595c60b&scoped=true"
import script from "./TextProject.vue?vue&type=script&lang=js"
export * from "./TextProject.vue?vue&type=script&lang=js"

import "./TextProject.vue?vue&type=style&index=0&id=2595c60b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2595c60b"]])

export default __exports__